import { useEffect } from "react";
import loadClientScreen from "./loadClientScreen";

const CLIENT_SCREEN_PREFETCH_DELAY_MS = 1000;

/**
 * The student profile is a large lazy-loaded chunk. Warm its runtime-cache
 * entry from every admin route so a tab left open across a deploy can still
 * open profiles using the version of the app it already has loaded.
 */
export default function ClientScreenPreloader(): null {
  useEffect(() => {
    const prefetchTimer = window.setTimeout(() => {
      loadClientScreen().catch(() => undefined);
    }, CLIENT_SCREEN_PREFETCH_DELAY_MS);

    return () => window.clearTimeout(prefetchTimer);
  }, []);

  return null;
}
